import React, { FormEvent } from 'react';

import Modal from '@components/modal';
import { NotifyForm } from '@components/notifyForm';

const copy = {
  infoForm:
    'Provide your email address to get updates from Platform and to be alerted if this or similar works become available.',
  infoConfirmation: "You've been added to the waitlist.",
  submit: 'ADD TO WAITLIST',
};

const copyPrelaunchable = {
  infoForm: 'Provide your email address to get updates from Platform and to be notified when this artwork launches.',
  infoConfirmation: 'You will be notified when the artwork becomes available.',
  submit: 'NOTIFY ME',
};

interface WaitlistModalProps {
  onModalClose: () => void;
  onFormSubmit: (
    event: FormEvent,
    { email, firstName, lastName }: { email: string; firstName: string; lastName: string }
  ) => void;
  isModalOpen: boolean;
  isConfirmationVisible: boolean;
  isPrelaunchable?: boolean;
  shouldOverridePrelaunchableCopy?: boolean;
  texts?: {
    infoForm: string;
    infoConfirmation: string;
    submit: string;
  };
  initialFields?: {
    firstName?: string;
    lastName?: string;
    email?: string;
    isChecked?: boolean;
  };
}

export const WaitlistModal = ({
  onModalClose,
  onFormSubmit,
  isModalOpen,
  isConfirmationVisible,
  initialFields,
  isPrelaunchable,
  shouldOverridePrelaunchableCopy,
  texts = shouldOverridePrelaunchableCopy ? copy : isPrelaunchable ? copyPrelaunchable : copy,
}: WaitlistModalProps) => {
  return (
    <Modal
      wrapperId="react-portal-waitlist-modal-container"
      headerText="Waitlist:"
      handleOnClose={onModalClose}
      isOpen={isModalOpen}
    >
      <NotifyForm
        onFormSubmit={onFormSubmit}
        isConfirmationVisible={isConfirmationVisible}
        initialFields={initialFields}
        texts={{
          info: texts.infoForm,
          submit: texts.submit,
          confirmation: texts.infoConfirmation,
        }}
      />
    </Modal>
  );
};
